import {
  HOME,
  SYSTEM,
  DISPATCHER_ORDER,
  SUR_BABYROOM_LIST,
  TUINA_BOARD,
  TUINA_APPOINTMENTS,
  TUINA_PROJECTS,
  TUINA_TECHNICIANS,
  TUINA_ROSTER,
  TUINA_MEMBERS,
  TUINA_ORDERS
} from '@/constants/menuPermissionMeta'

export const MATERNITY_GROUP_KEY = 'maternity'
export const TUINA_GROUP_KEY = 'tuina'

/* eslint-disable */
/**
 * Ant Design Menu `items` 配置（§4.5.1）
 * - `menuCode`：单码，用户 menuCodes 需包含该码
 * - `menuCodes`：多码，至少命中其一
 * - 二者均缺省：不按菜单 RBAC 拦截（全员可见）
 *
 * 一级按品类：月子 / 按摩 / 系统管理。
 * 月子 / 按摩子项走左侧栏，不进顶栏下拉；父级无 menuCodes，显隐由子项决定。
 */
const menus = [
  {
    label: '月子',
    key: MATERNITY_GROUP_KEY,
    children: [
      {
        label: '可视化大屏',
        menuCodes: [HOME],
        key: '/client/visualScreen'
      },
      {
        label: '首页',
        menuCodes: [HOME],
        key: '/client/commandCenter'
      },
      {
        label: '订单列表',
        menuCodes: ['order:list'],
        key: '/client/order/orderList'
      },
      {
        label: '派单',
        menuCodes: ['order:dispatcher', DISPATCHER_ORDER],
        key: '/client/order/dispatch'
      },
      // {
      //   label: '派单管理',
      //   menuCodes: ['order:dispatchersyttem'],
      //   key: '/client/order/dispatchManagement'
      // },
      // {
      //   label: '客户管理',
      //   menuCodes: ['order:customer'],
      //   key: '/client/order/customerList'
      // },
      {
        label: '服务通知管理',
        menuCodes: ['order:servicenotification'],
        key: '/client/order/serviceNotification'
      },
      {
        label: '设备列表',
        menuCodes: ['ys:list'],
        key: '/client/ys7/devices'
      },
      {
        label: '预警记录',
        menuCodes: ['ys:log'],
        key: '/client/ys7/log'
      },
      {
        label: '婴儿监控',
        menuCodes: [SUR_BABYROOM_LIST],
        key: '/client/surveillance/list'
      }
    ]
  },
  {
    label: '按摩',
    key: TUINA_GROUP_KEY,
    children: [
      {
        label: '日看板',
        menuCodes: [TUINA_BOARD],
        key: '/client/tuina/board'
      },
      {
        label: '预约列表',
        menuCodes: [TUINA_APPOINTMENTS],
        key: '/client/tuina/appointments'
      },
      {
        label: '订单列表',
        menuCodes: [TUINA_ORDERS],
        key: '/client/tuina/orders'
      },
      {
        label: '服务项目',
        menuCodes: [TUINA_PROJECTS],
        key: '/client/tuina/projects'
      },
      {
        label: '师傅',
        menuCodes: [TUINA_TECHNICIANS],
        key: '/client/tuina/technicians'
      },
      {
        label: '排班',
        menuCodes: [TUINA_ROSTER],
        key: '/client/tuina/roster'
      },
      {
        label: '会员',
        menuCodes: [TUINA_MEMBERS],
        key: '/client/tuina/members'
      }
    ]
  },
  {
    label: '系统管理',
    menuCodes: [SYSTEM],
    children: [
      {
        label: '成员列表',
        menuCodes: ['system:agent'],
        key: '/client/systemControl/agents'
      },
      {
        label: '角色管理',
        menuCodes: ['system:role'],
        key: '/client/systemControl/roleList'
      },
      {
        label: '权限管理',
        menuCodes: ['system:rbac'],
        key: '/client/systemControl/permissionList'
      },
      // {
      //   label: '资源管理',
      //   menuCodes: [],
      //   key: '/client/systemControl/resourceList'
      // }
    ]
  }
]

/** 顶栏当前属于哪一组：maternity / tuina / system */
export function getClientTopGroupKey (pathname) {
  if (typeof pathname !== 'string' || !pathname.startsWith('/client')) return ''
  if (pathname.startsWith('/client/tuina') || pathname.startsWith('/client/massage')) return TUINA_GROUP_KEY
  if (pathname.startsWith('/client/systemControl')) return 'system'
  return MATERNITY_GROUP_KEY
}

/** 月子业务页是否展示左侧栏（大屏 / 世界指挥中心 / 手机派单除外） */
export function shouldShowMaternitySider (pathname) {
  if (getClientTopGroupKey(pathname) !== MATERNITY_GROUP_KEY) return false
  if (pathname.includes('/visualScreen')) return false
  if (pathname.includes('/worldCommandCenter')) return false
  if (pathname.includes('/dispatchNewOrdersMobile')) return false
  return true
}

/** 左侧栏对应的一级 key；空字符串表示不展示侧栏 */
export function getClientSiderGroupKey (pathname) {
  const group = getClientTopGroupKey(pathname)
  if (group === TUINA_GROUP_KEY) return TUINA_GROUP_KEY
  if (shouldShowMaternitySider(pathname)) return MATERNITY_GROUP_KEY
  return ''
}

/** 顶栏点「月子」时的落地：优先首页，避开可视化大屏 */
export function getMaternityDefaultPath (headerItems) {
  const group = (headerItems || []).find((item) => item && item.key === MATERNITY_GROUP_KEY)
  const keys = (group && group.children ? group.children : [])
    .map((child) => child && child.key)
    .filter((key) => typeof key === 'string' && key.startsWith('/'))
  if (keys.includes('/client/commandCenter')) return '/client/commandCenter'
  const withoutScreen = keys.filter((key) => key !== '/client/visualScreen')
  return withoutScreen[0] || keys[0] || '/client/commandCenter'
}

/** 顶栏点「按摩」时的落地：日看板 */
export function getTuinaDefaultPath (headerItems) {
  const group = (headerItems || []).find((item) => item && item.key === TUINA_GROUP_KEY)
  const keys = (group && group.children ? group.children : [])
    .map((child) => child && child.key)
    .filter((key) => typeof key === 'string' && key.startsWith('/'))
  if (keys.includes('/client/tuina/board')) return '/client/tuina/board'
  return keys[0] || '/client/tuina/board'
}

export default menus
